// Written by cases/tools/area_icons.py from cases/area-icons.json (docs/61): change the file and run the script, not this.

export interface AreaIconTopic {
  readonly words: readonly string[];
  readonly emoji: readonly string[];
}

export const AREA_ICON_WORDS: { readonly default: string; readonly oftenUsed: readonly string[]; readonly topics: readonly AreaIconTopic[] } = {
  "default": "🗂️",
  "oftenUsed": [
    "🏡",
    "🏃",
    "💰",
    "📚",
    "✈️",
    "🎨",
    "🛒",
    "🌱",
    "🎓",
    "🧘",
    "🔧",
    "🎵",
    "🐶",
    "🍳",
    "❤️",
    "🎮"
  ],
  "topics": [
    {
      "words": [
        "work",
        "arbeit*",
        "job",
        "jobs",
        "büro",
        "office",
        "beruf*",
        "werk"
      ],
      "emoji": [
        "💼",
        "💻",
        "🏢",
        "📊",
        "🗂️",
        "🤝",
        "📈",
        "🖇️"
      ]
    },
    {
      "words": [
        "clients",
        "client",
        "kunde",
        "kunden",
        "customers",
        "customer",
        "mandanten",
        "mandant"
      ],
      "emoji": [
        "🤝",
        "💼",
        "📞",
        "📧",
        "🧾",
        "📈",
        "🗂️",
        "💬"
      ]
    },
    {
      "words": [
        "business",
        "geschäft",
        "geschäftlich",
        "selbstständig",
        "selbständig",
        "freelance",
        "freelancing",
        "freiberuflich",
        "side hustle"
      ],
      "emoji": [
        "🧾",
        "💼",
        "📈",
        "💰",
        "🏢",
        "🤝",
        "📊",
        "🗂️"
      ]
    },
    {
      "words": [
        "company",
        "firma",
        "unternehmen",
        "startup",
        "gmbh",
        "agentur",
        "agency"
      ],
      "emoji": [
        "🏢",
        "💼",
        "🚀",
        "📈",
        "📊",
        "👥",
        "🤝",
        "🗂️"
      ]
    },
    {
      "words": [
        "team",
        "mitarbeiter",
        "staff",
        "kollegen",
        "colleagues"
      ],
      "emoji": [
        "👥",
        "🤝",
        "💬",
        "🗣️",
        "📅",
        "🏢",
        "💼",
        "🧑‍💻"
      ]
    },
    {
      "words": [
        "studies",
        "study",
        "studium",
        "studieren",
        "uni",
        "university",
        "universität",
        "hochschule",
        "college",
        "school",
        "schule"
      ],
      "emoji": [
        "🎓",
        "📚",
        "📝",
        "🏫",
        "🧠",
        "💻",
        "📖",
        "✏️"
      ]
    },
    {
      "words": [
        "training",
        "ausbildung",
        "apprenticeship",
        "azubi",
        "lehre"
      ],
      "emoji": [
        "🛠️",
        "🎓",
        "📚",
        "🧰",
        "📝",
        "🏋️",
        "💪",
        "🧠"
      ]
    },
    {
      "words": [
        "health",
        "gesundheit",
        "wellbeing",
        "wellness",
        "medical",
        "arzt",
        "ärzte",
        "doctor",
        "doctors",
        "körper",
        "body"
      ],
      "emoji": [
        "🏃",
        "🩺",
        "💊",
        "🧘",
        "🍎",
        "💪",
        "😴",
        "❤️‍🩹"
      ]
    },
    {
      "words": [
        "fitness",
        "sport*",
        "workout",
        "gym",
        "fitnessstudio",
        "laufen",
        "running",
        "joggen",
        "jogging",
        "radfahren",
        "cycling",
        "schwimmen",
        "swimming",
        "fußball",
        "football",
        "tennis"
      ],
      "emoji": [
        "💪",
        "🏋️",
        "🏃",
        "🚴",
        "🧘",
        "🏊",
        "⚽",
        "🎾"
      ]
    },
    {
      "words": [
        "yoga",
        "meditation",
        "achtsamkeit",
        "mindfulness",
        "mental",
        "mind",
        "self care",
        "selfcare",
        "selbstfürsorge"
      ],
      "emoji": [
        "🧘",
        "🌿",
        "🕯️",
        "🧠",
        "😌",
        "☯️",
        "🌱",
        "💆"
      ]
    },
    {
      "words": [
        "money",
        "geld",
        "finanz*",
        "finances",
        "finance",
        "budget",
        "steuer*",
        "taxes",
        "tax",
        "bank",
        "banking",
        "sparen",
        "saving",
        "savings",
        "invest*",
        "rechnungen",
        "bills"
      ],
      "emoji": [
        "💰",
        "💳",
        "🏦",
        "📈",
        "🧾",
        "💶",
        "💵",
        "🪙"
      ]
    },
    {
      "words": [
        "home",
        "zuhause",
        "zu hause",
        "daheim",
        "haushalt",
        "household",
        "wohnung",
        "wohnen",
        "apartment",
        "flat",
        "putzen",
        "cleaning",
        "chores"
      ],
      "emoji": [
        "🏡",
        "🛋️",
        "🧹",
        "🔧",
        "🛒",
        "🧺",
        "🪴",
        "🔑"
      ]
    },
    {
      "words": [
        "house",
        "haus",
        "häuser",
        "hausbau",
        "hausarbeit",
        "renovation",
        "renovierung",
        "umzug",
        "moving",
        "diy",
        "heimwerken",
        "repairs",
        "reparaturen"
      ],
      "emoji": [
        "🏠",
        "🔨",
        "🔧",
        "🛠️",
        "🪜",
        "🏡",
        "🧱",
        "🔑"
      ]
    },
    {
      "words": [
        "learning",
        "lern*",
        "learn",
        "course",
        "courses",
        "kurs",
        "weiterbildung",
        "fortbildung",
        "bildung",
        "education",
        "skills",
        "sprachen",
        "languages"
      ],
      "emoji": [
        "🌱",
        "📚",
        "🎓",
        "🧠",
        "✏️",
        "💡",
        "📝",
        "🗣️"
      ]
    },
    {
      "words": [
        "hobbies",
        "hobby",
        "freizeit",
        "leisure",
        "fun",
        "spaß",
        "crafts",
        "basteln"
      ],
      "emoji": [
        "🎨",
        "🎸",
        "📷",
        "🧶",
        "🎮",
        "🎲",
        "🧩",
        "🪁"
      ]
    },
    {
      "words": [
        "friends & community",
        "freunde & gemeinschaft"
      ],
      "emoji": [
        "🤝",
        "🥂",
        "🙌",
        "👯",
        "🏘️",
        "🎉",
        "💬",
        "❤️"
      ]
    },
    {
      "words": [
        "friends",
        "friend",
        "freund",
        "freundinnen",
        "social",
        "soziales"
      ],
      "emoji": [
        "🥂",
        "👯",
        "🎉",
        "💬",
        "☕",
        "🍻",
        "🤝",
        "📞"
      ]
    },
    {
      "words": [
        "travel",
        "travels",
        "traveling",
        "travelling",
        "reise*",
        "urlaub",
        "vacation",
        "vacations",
        "holiday",
        "holidays",
        "trip",
        "trips",
        "ferien"
      ],
      "emoji": [
        "✈️",
        "🧳",
        "🗺️",
        "🏖️",
        "🏝️",
        "🚆",
        "🏕️",
        "🌍"
      ]
    },
    {
      "words": [
        "career",
        "karriere",
        "bewerbung*",
        "job search",
        "jobsuche",
        "applications"
      ],
      "emoji": [
        "📈",
        "🎯",
        "💼",
        "🧭",
        "🎓",
        "🏆",
        "🚀",
        "📊"
      ]
    },
    {
      "words": [
        "giving back",
        "engagement",
        "ehrenamt*",
        "volunteering",
        "volunteer",
        "charity",
        "community",
        "gemeinschaft",
        "verein",
        "causes",
        "spenden",
        "donations"
      ],
      "emoji": [
        "🙌",
        "🤝",
        "❤️",
        "🌍",
        "🫶",
        "🏘️",
        "🎗️",
        "🌱"
      ]
    },
    {
      "words": [
        "loved ones",
        "meine liebsten",
        "liebsten",
        "partner",
        "partnerin",
        "beziehung",
        "relationship",
        "love",
        "liebe",
        "ehe",
        "marriage"
      ],
      "emoji": [
        "❤️",
        "💑",
        "💕",
        "🌹",
        "💍",
        "🥰",
        "🏡",
        "👨‍👩‍👧"
      ]
    },
    {
      "words": [
        "family",
        "familie",
        "families",
        "eltern",
        "parents",
        "verwandte",
        "relatives"
      ],
      "emoji": [
        "👨‍👩‍👧",
        "🏡",
        "❤️",
        "🧸",
        "👶",
        "🎂",
        "🍼",
        "🎈"
      ]
    },
    {
      "words": [
        "kids",
        "kid",
        "kinder*",
        "kind",
        "children",
        "child",
        "baby",
        "babys",
        "babies"
      ],
      "emoji": [
        "🧸",
        "👶",
        "🎈",
        "🍼",
        "🎒",
        "🛝",
        "👨‍👩‍👧",
        "❤️"
      ]
    },
    {
      "words": [
        "pets",
        "pet",
        "haustier",
        "dog",
        "dogs",
        "hund",
        "hundeschule",
        "cat",
        "cats",
        "katze",
        "tiere",
        "animals"
      ],
      "emoji": [
        "🐶",
        "🐱",
        "🐾",
        "🐕",
        "🐈",
        "🦴",
        "🐠",
        "🐰"
      ]
    },
    {
      "words": [
        "garden",
        "gardening",
        "garten*",
        "pflanzen",
        "plants",
        "balkon",
        "balcony"
      ],
      "emoji": [
        "🌱",
        "🌻",
        "🪴",
        "🌳",
        "🌷",
        "🥕",
        "🧑‍🌾",
        "🐝"
      ]
    },
    {
      "words": [
        "car",
        "cars",
        "auto",
        "autos",
        "vehicle",
        "fahrzeug",
        "kfz",
        "motorrad",
        "motorcycle"
      ],
      "emoji": [
        "🚗",
        "🔧",
        "⛽",
        "🚙",
        "🛞",
        "🅿️",
        "🧽",
        "🏍️"
      ]
    },
    {
      "words": [
        "side projects",
        "side project",
        "nebenprojekt"
      ],
      "emoji": [
        "🚀",
        "💡",
        "🛠️",
        "🧪",
        "💻",
        "🎯",
        "🌙",
        "✨"
      ]
    },
    {
      "words": [
        "projects",
        "project",
        "projekt"
      ],
      "emoji": [
        "🗂️",
        "📁",
        "🚀",
        "💡",
        "🛠️",
        "📋",
        "✅",
        "📌"
      ]
    },
    {
      "words": [
        "church",
        "kirche",
        "gemeinde",
        "faith",
        "glaube",
        "glauben",
        "religion",
        "gottesdienst",
        "bible",
        "bibel",
        "prayer",
        "gebet"
      ],
      "emoji": [
        "⛪",
        "🙏",
        "📖",
        "🕊️",
        "✝️",
        "🕯️",
        "🎶",
        "🤝"
      ]
    },
    {
      "words": [
        "music",
        "musik*",
        "band",
        "gitarre",
        "guitar",
        "piano",
        "klavier",
        "singing",
        "singen",
        "chor",
        "choir"
      ],
      "emoji": [
        "🎵",
        "🎸",
        "🎹",
        "🎤",
        "🥁",
        "🎧",
        "🎻",
        "🎼"
      ]
    },
    {
      "words": [
        "reading",
        "read",
        "lesen",
        "books",
        "book",
        "buch",
        "bücher",
        "literature",
        "literatur"
      ],
      "emoji": [
        "📚",
        "📖",
        "🔖",
        "📝",
        "☕",
        "🛋️",
        "🎬",
        "📺"
      ]
    },
    {
      "words": [
        "watch",
        "film",
        "films",
        "movies",
        "movie",
        "serie",
        "series",
        "tv",
        "kino",
        "cinema"
      ],
      "emoji": [
        "🎬",
        "🍿",
        "📺",
        "🎞️",
        "🎥",
        "🛋️",
        "📚",
        "🎭"
      ]
    },
    {
      "words": [
        "cooking",
        "cook",
        "koch*",
        "backen",
        "baking",
        "recipes",
        "rezept",
        "essen",
        "food",
        "meals",
        "meal prep",
        "küche",
        "kitchen"
      ],
      "emoji": [
        "🍳",
        "🥘",
        "🥗",
        "🧑‍🍳",
        "🍰",
        "🛒",
        "🥕",
        "🍲"
      ]
    },
    {
      "words": [
        "shopping",
        "einkaufen",
        "einkauf",
        "einkäufe",
        "groceries",
        "besorgungen",
        "errands"
      ],
      "emoji": [
        "🛒",
        "🛍️",
        "🧾",
        "🥖",
        "🍎",
        "💳",
        "📝",
        "🏪"
      ]
    },
    {
      "words": [
        "art",
        "arts",
        "kunst",
        "malen",
        "painting",
        "drawing",
        "zeichnen",
        "design",
        "kreativ",
        "creative",
        "creativity"
      ],
      "emoji": [
        "🎨",
        "🖌️",
        "✏️",
        "🖼️",
        "🧵",
        "✂️",
        "📷",
        "💡"
      ]
    },
    {
      "words": [
        "photography",
        "foto*",
        "photo*",
        "kamera",
        "camera"
      ],
      "emoji": [
        "📷",
        "📸",
        "🖼️",
        "🎞️",
        "🌄",
        "🎨",
        "💡",
        "🗺️"
      ]
    },
    {
      "words": [
        "gaming",
        "games",
        "game",
        "spiele",
        "videospiele",
        "zocken"
      ],
      "emoji": [
        "🎮",
        "🕹️",
        "🎲",
        "🧩",
        "👾",
        "🏆",
        "🎯",
        "♟️"
      ]
    },
    {
      "words": [
        "writing",
        "schreiben",
        "blog",
        "journal",
        "tagebuch",
        "diary"
      ],
      "emoji": [
        "✍️",
        "📝",
        "📓",
        "🖋️",
        "💡",
        "📚",
        "💻",
        "☕"
      ]
    },
    {
      "words": [
        "personal",
        "persönlich",
        "privat",
        "private",
        "me",
        "ich",
        "self",
        "selbst",
        "life",
        "leben"
      ],
      "emoji": [
        "🌟",
        "🙂",
        "🏡",
        "❤️",
        "🌱",
        "🧘",
        "✨",
        "📔"
      ]
    },
    {
      "words": [
        "admin",
        "verwaltung",
        "papierkram",
        "paperwork",
        "bürokratie",
        "behörden",
        "documents",
        "dokumente",
        "versicherung*",
        "insurance",
        "verträge",
        "contracts"
      ],
      "emoji": [
        "📄",
        "🗂️",
        "🖇️",
        "📋",
        "✉️",
        "🏛️",
        "🧾",
        "📎"
      ]
    },
    {
      "words": [
        "events",
        "event",
        "party",
        "partys",
        "parties",
        "feiern",
        "feste",
        "geburtstag",
        "birthdays",
        "wedding",
        "hochzeit"
      ],
      "emoji": [
        "🎉",
        "🎂",
        "🎈",
        "🥳",
        "💍",
        "📅",
        "🎁",
        "🍾"
      ]
    },
    {
      "words": [
        "outdoor",
        "outdoors",
        "natur",
        "nature",
        "wandern",
        "hiking",
        "camping",
        "berge",
        "mountains"
      ],
      "emoji": [
        "🏞️",
        "🥾",
        "⛰️",
        "🏕️",
        "🌲",
        "🧭",
        "🌄",
        "🎒"
      ]
    },
    {
      "words": [
        "computer",
        "tech",
        "technik",
        "software",
        "coding",
        "programmieren",
        "code",
        "development",
        "entwicklung"
      ],
      "emoji": [
        "💻",
        "⌨️",
        "🖥️",
        "🧑‍💻",
        "🛠️",
        "🐛",
        "📱",
        "⚙️"
      ]
    },
    {
      "words": [
        "ideas",
        "idea",
        "ideen",
        "idee",
        "inspiration"
      ],
      "emoji": [
        "💡",
        "✨",
        "🧠",
        "📝",
        "🚀",
        "🌈",
        "🎯",
        "🗒️"
      ]
    }
  ]
};
